import { condClass, finishClass } from "@/lib/api";

export const FormHistory = ({ starts = [], testid, live }) => {
  if (!starts.length) return <p className="text-xs text-slate-500 py-2" data-testid={testid}>{live ? "No previous starts on record for this horse." : "No previous starts recorded."}</p>;
  return (
    <div className="overflow-x-auto" data-testid={testid}>
      <table className="w-full text-xs font-mono">
        <thead>
          <tr className="text-slate-500 text-left uppercase tracking-wider">
            <th className="py-2 pr-3">Date</th><th className="pr-3">Track</th><th className="pr-3">Dist</th>
            <th className="pr-3">Fin</th><th className="pr-3">Margin</th><th className="pr-3">Cond</th><th className="pr-3">Wt</th>
            <th className="pr-3" title="Last 600m time">L600</th><th className="pr-3" title="Starting price">SP</th><th>Jockey</th>
          </tr>
        </thead>
        <tbody>
          {starts.map((s, i) => (
            <tr key={i} className="border-t border-white/5 text-slate-200">
              <td className="py-2 pr-3 whitespace-nowrap">{s.date || "-"}</td>
              <td className="pr-3 whitespace-nowrap">{s.track || "-"}</td>
              <td className="pr-3">{s.distance ? `${s.distance}m` : "-"}</td>
              <td className="pr-3">
                <span className={`inline-flex min-w-[2.6rem] justify-center px-1.5 py-0.5 rounded font-bold ${finishClass(s.finish)}`}>
                  {s.finish ?? "-"}{s.field_size ? `/${s.field_size}` : ""}
                </span>
              </td>
              <td className="pr-3">{s.finish === 1 ? "WON" : s.margin != null ? `${s.margin}L` : "-"}</td>
              <td className="pr-3">{s.condition ? <span className={`px-1.5 py-0.5 rounded border ${condClass(s.condition)}`}>{s.condition}</span> : "-"}</td>
              <td className="pr-3">{s.weight ? `${s.weight}kg` : "-"}</td>
              <td className="pr-3">{s.l600 ? `${s.l600}s` : "-"}</td>
              <td className="pr-3">{s.sp ? `$${s.sp}` : "-"}</td>
              <td className="whitespace-nowrap">{s.jockey || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
